import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Laboral } from '../model/laboral.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LaboralService {
  private apiUrl =  `${environment.apiUrl}/api/laborales`; 
  //private apiUrl = 'http://localhost:3000/api/laborales';

  constructor(private http: HttpClient) {}

  private manejarError(error: HttpErrorResponse): Observable<never> {
    let mensaje = 'Ocurrió un error inesperado';
    if (error.error?.message) {
      mensaje = error.error.message;
    }
    return throwError(() => new Error(mensaje));
  }

  // Obtener todos los registros laborales
  getLaborales(): Observable<Laboral[]> {
    return this.http.get<Laboral[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Obtener un registro laboral por ID
  getLaboralById(id: number): Observable<Laboral> {
    return this.http.get<Laboral>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Crear un nuevo registro laboral
  createLaboral(laboral: Laboral): Observable<Laboral> {
    return this.http.post<Laboral>(this.apiUrl, laboral, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Actualizar un registro laboral
  updateLaboral(id: number, laboral: Laboral): Observable<Laboral> {
    return this.http.put<Laboral>(`${this.apiUrl}/${id}`, laboral, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Eliminar un registro laboral por ID
  deleteLaboral(id: number): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Obtener registros laborales por cédula
  getLaboralByCedula(cedula: string): Observable<Laboral[]> {
    return this.http.get<Laboral[]>(`${this.apiUrl}/cedula/${cedula}`, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }
}
